import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { VERSION } from '../version';

function IcoDashboard({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" rx="1.5"/>
      <rect x="14" y="3" width="7" height="5" rx="1.5"/>
      <rect x="14" y="12" width="7" height="9" rx="1.5"/>
      <rect x="3" y="16" width="7" height="5" rx="1.5"/>
    </svg>
  );
}

function IcoReview({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
      <rect x="9" y="3" width="6" height="4" rx="1"/>
      <line x1="9" y1="12" x2="15" y2="12"/>
      <line x1="9" y1="16" x2="13" y2="16"/>
    </svg>
  );
}

function IcoFeed({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );
}

function IcoSubmit({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
      <circle cx="12" cy="13" r="4"/>
    </svg>
  );
}

function IcoMine({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  );
}

function IcoTrophy({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 21h8m-4-4v4M17 4v6a5 5 0 01-10 0V4"/>
      <path d="M7 4H4a1 1 0 00-1 1v1a4 4 0 004 4"/>
      <path d="M17 4h3a1 1 0 011 1v1a4 4 0 01-4 4"/>
    </svg>
  );
}

function IcoUsers({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87"/>
      <path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  );
}

function IcoBell({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 01-3.46 0"/>
    </svg>
  );
}

function IcoLog({ c }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

const ICONS = {
  dashboard: IcoDashboard,
  review: IcoReview,
  feed: IcoFeed,
  submit: IcoSubmit,
  mine: IcoMine,
  trophy: IcoTrophy,
  users: IcoUsers,
  bell: IcoBell,
  log: IcoLog,
};

const STAFF_TABS = [
  { path: '/feed',      label: 'Feed',       iconKey: 'feed' },
  { path: '/submit',    label: 'Submit',     iconKey: 'submit' },
  { path: '/mine',      label: 'My Moments', iconKey: 'mine' },
  { path: '/thismonth', label: 'This Month', iconKey: 'trophy' },
];

const ADMIN_TABS = [
  { path: '/dashboard', label: 'Dashboard',  iconKey: 'dashboard' },
  { path: '/admin',     label: 'Review',     iconKey: 'review' },
  { path: '/feed',      label: 'Feed',       iconKey: 'feed' },
  { path: '/thismonth', label: 'This Month', iconKey: 'trophy' },
  { path: '/users',         label: 'People',     iconKey: 'users' },
  { path: '/notifications', label: 'Notify',     iconKey: 'bell' },
  { path: '/logs',          label: 'Logs',        iconKey: 'log' },
];

export default function Nav({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = user.role === 'admin' ? ADMIN_TABS : STAFF_TABS;

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: 'linear-gradient(135deg, #ffffff 0%, #fdf7f9 100%)',
      boxShadow: '0 2px 16px rgba(219,50,103,0.08), 0 1px 4px rgba(0,0,0,0.05)',
    }}>
      {/* Top row: logo + user + sign out */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 16px', height: '50px',
        borderBottom: '1px solid rgba(219,50,103,0.08)',
      }}>
        <img src="/sah-logo.svg" alt="Support at Home" style={{ height: '28px', width: 'auto' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button
            onClick={() => navigate('/password')}
            style={{ background: 'none', border: 'none', fontSize: '12px', color: '#aaa', fontWeight: '500', cursor: 'pointer', padding: 0 }}
            title="Change password"
          >{user.name}</button>
          <button
            onClick={onLogout}
            style={{
              background: 'none', border: '1px solid #e8e8ee',
              padding: '5px 13px', borderRadius: '20px',
              fontSize: '12px', color: '#999', fontWeight: '500', cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        </div>
      </div>

      {/* Tab row */}
      <div style={{
        display: 'flex', overflowX: 'auto', padding: '0 4px',
        borderBottom: '2.5px solid #DB3267',
        scrollbarWidth: 'none', msOverflowStyle: 'none',
      }}>
        <span style={{
          marginLeft: 'auto', padding: '0 12px',
          fontSize: '10px', color: '#ddd', fontWeight: '600',
          alignSelf: 'center', flexShrink: 0,
        }}>{VERSION}</span>

        {tabs.map(tab => {
          const active = location.pathname === tab.path;
          const color = active ? '#DB3267' : '#aaa';
          const Icon = ICONS[tab.iconKey];
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              style={{
                display: 'flex', alignItems: 'center', gap: '5px',
                padding: '10px 14px', background: 'none', border: 'none',
                borderBottom: active ? '2.5px solid #DB3267' : '2.5px solid transparent',
                marginBottom: '-2.5px',
                color, fontSize: '12px', fontWeight: active ? '700' : '500',
                cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
              }}
            >
              <Icon c={color} />
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
